/*
  The skin — the second of the site's two independent visual axes.

    Mode  `data-theme`  light | dark      chosen by the visitor or their OS, at runtime
    Skin  `data-skin`   navy  | gilded | event    chosen HERE, at build time, for everyone

  A visitor never picks the skin. It is an internal flag so that gilded can ship as
  the default look while navy stays bootable, and so that backing gilded out is a
  one-line change and a redeploy rather than a git revert and a re-review.

  THE VALUE LIVES IN `.env`, NOT HERE. See the comment in that file for why: the
  attribute has to be on <html> before the first paint, and public/index.html cannot
  import from src/. CRA substitutes %REACT_APP_SKIN% into the HTML and inlines
  process.env.REACT_APP_SKIN into the bundle from the same single line, so the markup
  and the React code cannot drift apart.

  This module is the typed reader of that line. Everything in src/ that needs the skin
  imports SKIN from here and never touches process.env itself.
*/

/*
  `event` is the third skin and the default since 2026-10-19: the dark purple-grey and
  brand gold of the PCG event guide pages (the Riftbound RC Europe guide), with a white
  light mode. Gilded stays in the tree and bootable exactly as navy did when gilded
  arrived, so backing `event` out is the same one line in .env.
*/
export type Skin = "navy" | "gilded" | "event";

/*
  The fallback when the variable is absent or misspelled. Navy, deliberately: it is the
  look that was live before this branch, so a build with a broken .env degrades to a
  known-good page instead of to a hybrid nobody designed. The CSS falls back the same
  way — an unrecognised data-skin matches none of the gilded selectors, so navy's tokens
  apply — which means the two halves agree even in the failure case.
*/
export const DEFAULT_SKIN: Skin = "navy";

export const isSkin = (value: unknown): value is Skin =>
  value === "navy" || value === "gilded" || value === "event";

export const SKIN: Skin = isSkin(process.env.REACT_APP_SKIN)
  ? process.env.REACT_APP_SKIN
  : DEFAULT_SKIN;
